export const EXPERIMENTS_SCOPE = 'specs.groups';
export const TABS_HOOK = 'tabsHook';
export const GROUP_PAGE = 'group_page';
